module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic_1.cf163a0e.eot";